import firebase from "firebase/app";

import { useTranslation } from "react-i18next";

import deleteWork from "astrid-firestore/src/api/works/deleteWork";

import { useProfile } from "../../authentication/state/profile";

export default function useWorksTableDropdownMenuOptions() {
	const { t } = useTranslation();
	const user = useProfile();

	return (work) => [
		{
			text: t("view", "View"),
			linkTo: `/publisher/${work.publisher.id}/works/${work.id}`,
		},
		{
			text: t("delete", "Delete"),
			confirmText: t("deleteWorkConfirmation", "Do you want to delete this work and all its articles?"),
			action: () => deleteWork(firebase, { work, user }),
		},
	];
}
